import { Image, useComputedColorScheme } from '@mantine/core';
import { smartico_logo, ad_studio_logo, ad_studio_logo_dark } from '@/assets/img';

export const Logo = ({src = '', type = 'crm', lightOnly = false, ...props}) => { //define src so don't get replaced
    
    const computedColorScheme = useComputedColorScheme('light');

    const imageUrl = type == 'studio' ? (computedColorScheme === 'dark' && !lightOnly ? ad_studio_logo_dark : ad_studio_logo) : smartico_logo;

    return(
        <Image  w="auto" h={35} src={imageUrl} {...props}/>
    )
}